<template>
    <div class="image_saver_body">
        <div class="image_saver_box">
            <div class="image_saver_content">
                <!-- 标签 -->
                <div class="old_tabs">
                    <!-- 返回顶部 -->
                    <el-backtop class="image_saver_backtop" target=".old_tab" :right="36" :bottom="40"><div></div></el-backtop>
                    <!-- Instagram -->
                    <div class="old_tab" :data-init="insDatas.length==0?'Y':'N'">
                        <div class="imagesaver_input_button">
                            <el-input ref="insInputEle" class="imagesaver_input" type="textarea" autosize resize="none" :placeholder="insInputFocus?'':insInputText"
                                v-model="insUrls" @input="limitRowsInsUrls" spellcheck="false" @focus="insInputFocus=true" @blur="insInputFocus=false"></el-input>
                            <el-button type="primary" :disabled="insUrls == ''" @click="decodeInstagram"
                                :loading="insEncodeing">{{ insEncodeing ? $t('language.imageSaver.analyzing') : $t('language.imageSaver.download') }}</el-button>
                        </div>
                        <imageSaverPath v-show="node&&insDatas.length>0" :node="node" :updateTaskDestDrive="updateTaskDestDrive" :loadDestNode="loadDestNode"></imageSaverPath>
                        <!-- 友好空白页 -->
                        <div class="ins_blank" v-if="insDatas.length==0">
                            <div class="ins_blank_text">{{ $t('language.imageSaver.insBlankText') }}</div>
                            <imageSaverWelcome :welcomeData="welcomeData"></imageSaverWelcome>
                        </div>
                        <imageSaverView v-for="(item, index) of insDatas" :key="item.uuid" :item="curItem(item)"
                            :isPreview="true" :index="index" :addInstagramItems="addInstagramItems" :node="node" :itemsLength="insDatas.length" :inputHeight="insInputHeight"
                            :updateTaskDestDrive="updateTaskDestDrive" :viewImgWigth="viewImgWigth" :lineCount="lineCount" :noImageHeight="noImageHeight" :selectInsType="selectInsType" :insTypeSelect="insDatas[index].typeSubCur" :initTypeSub="insDatas[index].typeSub" :pageUpOrDown="pageUpOrDown">
                        </imageSaverView>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部波浪背景 -->
        <div class="task-buttom"></div>
    </div>
</template>

<script>
import imageSaverPath from "@/components/workspace/image_saver_path";
import imageSaverView from "@/components/workspace/image_saver_view";
import imageSaverWelcome from "@/components/workspace/image_saver_welcome";
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import Vue from 'vue';

export default {
    name: "imageSaverIns",
    components: {
        imageSaverWelcome,
        imageSaverView,
        imageSaverPath,
    },
    watch: {
        // 监听目的地变化
        '$store.state.imageSaverDestNode': function(newValue) {
            this.node = newValue;
            this.updateWindowSize();
        }
    },
    data() {
        return {
            // 目的地云盘节点
            node: null,
            // Instagram
            insUrls: "",
            insUrlsLast: "",
            insInputHeight: 0,
            insInputFocus: false,
            insInputText: this.$t('language.imageSaver.inputTipIns'),
            insEncodeing: false,
            insDatas: [],
            // 加载预览图
            isLoadPreviewImage: false,
            isLoadPreviewImageIng: false,
            // 预览图宽
            viewImgWigth: 0,
            // 一行放几个
            lineCount: 0,
            // 没有图片的外框高
            noImageHeight: 0,
            // 欢迎页数据
            welcomeData: [],
        };
    },
    mounted() {
        // 加载欢迎页数据
        taskListUtils.imageSaverRequest("/insWelcome", {count:7}, res => {
            if (res.code == 200) {
                this.welcomeData = res.data;
            }
        });
        // 初始化窗口大小变化
        this.updateWindowSize();
        // 监听窗口大小变化
        window.addEventListener('resize', this.updateWindowSize);
        // 获取任务目的地云盘
        this.loadDestNode();
        // 加载预览图
        this.loadPreviewImage = setInterval(() => {
            if (this.$route.name != 'imageSaverIns') return;
            // 如果启动了加载预览图
            if (this.isLoadPreviewImage) {
                // 如果当前并没有正在加载的
                if (!this.isLoadPreviewImageIng) {
                    // 标记为正在加载
                    this.isLoadPreviewImageIng = true;
                    // 等下要加载对象
                    var loadBeans = [];
                    // 解析出要加载对象
                    for (var i = 0; i < this.insDatas.length; i++) {
                        var insData = this.insDatas[i];
                        // 原生
                        this.pushReadyLoadBeans(loadBeans, insData.list);
                        // 附加
                        var subPosts = insData.subPosts;
                        if (subPosts && !subPosts.loading) {
                            this.pushReadyLoadBeans(loadBeans, subPosts.list);
                        }
                        var subReels = insData.subReels;
                        if (subReels && !subReels.loading) {
                            this.pushReadyLoadBeans(loadBeans, subReels.list);
                        }
                        var subStories = insData.subStories;
                        if (subStories && !subStories.loading) {
                            this.pushReadyLoadBeans(loadBeans, subStories.list);
                        }
                        var subHighlights = insData.subHighlights;
                        if (subHighlights && !subHighlights.loading) {
                            this.pushReadyLoadBeans(loadBeans, subHighlights.list);
                        }
                    }
                    // 如何处理
                    if (loadBeans.length > 0) {
                        // 开始加载预览图
                        taskListUtils.imageSaverRequest("/previews", {list: loadBeans}, res => {
                            if (res.code == 200) {
                                // 预览成功
                                var arr = res.data;
                                for (var i=0; i<arr.length; i++) {
                                    // 准备根据UUID匹配数据
                                    var uuid = arr[i].uuid;
                                    // 反正不在需要，就删除UUID
                                    delete arr[i].uuid;
                                    // 开始匹配
                                    for (var j=0; j<loadBeans.length; j++) {
                                        // 匹配成功
                                        if (loadBeans[j].uuid == uuid) {
                                            // 反正不在需要，就删除UUID
                                            delete loadBeans[j].uuid;
                                            // 更新数据
                                            Vue.set(loadBeans[j], 'preview', arr[i]);
                                            Vue.set(loadBeans[j], 'status', 'success');
                                            // 本轮匹配完成，继续下一轮匹配
                                            break;
                                        }
                                    }
                                }
                            } else {
                                // 预览失败
                                // this.errorTips("Loading preview failed.");
                            }
                            // 标记刚刚请求这些已经加载过
                            for (var i=0; i<loadBeans.length; i++) {
                                loadBeans[i].loaded = true;
                            }
                            // 标记本次请求完毕
                            this.isLoadPreviewImageIng = false;
                        });
                    } else {
                        // 所有预览图都已加载完，停止解析
                        this.isLoadPreviewImage = false;
                        this.isLoadPreviewImageIng = false;
                    }
                }
            }
        }, 200);
    },
    beforeDestroy() {
        // 清理定时器
        clearInterval(this.loadPreviewImage);
        // 移除窗口大小变化的监听
        window.removeEventListener('resize', this.updateWindowSize);
    },
    methods: {
        // 翻页
        pageUpOrDown(index, option, typeSubSelect) {
            var item = null;
            var insData = this.insDatas[index];
            if (insData.typeSub == typeSubSelect) {
                item = insData;
            } else if (typeSubSelect == 'posts') {
                item = insData.subPosts;
            } else if (typeSubSelect == 'reels') {
                item = insData.subReels;
            } else if (typeSubSelect == 'stories') {
                item = insData.subStories;
            } else if (typeSubSelect == 'highlights') {
                item = insData.subHighlights;
            }
            if (item != null) {
                if (option == 'up') {
                    item.pageIndex -= 1;
                } else if (option == 'down') {
                    item.pageIndex += 1;
                }
            }
        },
        // 准备要预览的数据
        pushReadyLoadBeans(loadBeans, list) {
            var max = 3;
            // 检测
            if (loadBeans.length >= max) return;
            if (!list) return;
            // 优化，如果最后一个没有加载过，才遍历
            var last = list[list.length-1];
            if (last && !last.loaded && !last.preview) {
                // 正常遍历
                for (var j = 0; j < list.length; j++) {
                    var bean = list[j];
                    if (!bean.loaded && !bean.preview) {
                        // 第一个没有预览过的对象
                        bean.uuid = this.generateUUID();
                        loadBeans.push(bean);
                        // 继续处理后续N个没有预览过的对象
                        const n = max - loadBeans.length;
                        for (var x=1; x<=n; x++) {
                            if (j+x < list.length) {
                                var tempBean = list[j+x];
                                if (!tempBean.loaded && !tempBean.preview) {
                                    // 设置UUID的目的是请求响应回来时需要与请求前的数据匹配
                                    tempBean.uuid = this.generateUUID();
                                    loadBeans.push(tempBean);
                                }
                            }
                        }
                        // 每个视图只匹配N+1个
                        break;
                    }
                }
            }
        },
        // 初始化Ins附加数据
        initInsOtherData(item, type) {
            return {
                        type: item.type,
                        typeSub: type,
                        source: item.source,
                        domain: item.domain,
                        favicon: item.favicon,
                        faviconURL: item.faviconURL,
                        posts: item.posts,
                        followed: item.followed,
                        follow: item.follow,
                        list: [{}],
                        loading: true,
                        isError: false,
                        isRetry: false,
                        isLoadedNext: false,
                        pageIndex: 1,
                        msg: '',
                    };
        },
        // 当前选择的item
        curItem(item) {
            if (item.typeSub == item.typeSubCur) {
                // 原生
                return item;
            } else if (item.typeSubCur == 'posts') {
                // 附加
                var subPosts = item.subPosts;
                if (subPosts) {
                    // 重试
                    if (!subPosts.loading && subPosts.isError && subPosts.isRetry) {
                        subPosts.loading = true;
                        subPosts.isError = false;
                        subPosts.isRetry = false;
                        this.decodeInsSub(item, 'posts');
                    }
                    // 缓存
                    return subPosts;
                } else {
                    // 初始化
                    subPosts = this.initInsOtherData(item, 'posts');
                    Vue.set(item, 'subPosts', subPosts);
                    // 准备加载
                    this.decodeInsSub(item, 'posts');
                    return item.subPosts;
                }
            } else if (item.typeSubCur == 'reels') {
                // 附加
                var subReels = item.subReels;
                if (subReels) {
                    // 重试
                    if (!subReels.loading && subReels.isError && subReels.isRetry) {
                        subReels.loading = true;
                        subReels.isError = false;
                        subReels.isRetry = false;
                        this.decodeInsSub(item, 'reels');
                    }
                    // 缓存
                    return subReels;
                } else {
                    // 初始化
                    subReels = this.initInsOtherData(item, 'reels');
                    Vue.set(item, 'subReels', subReels);
                    // 准备加载
                    this.decodeInsSub(item, 'reels');
                    return item.subReels;
                }
            } else if (item.typeSubCur == 'stories') {
                // 附加
                var subStories = item.subStories;
                if (subStories) {
                    // 重试
                    if (!subStories.loading && subStories.isError && subStories.isRetry) {
                        subStories.loading = true;
                        subStories.isError = false;
                        subStories.isRetry = false;
                        this.decodeInsSub(item, 'stories');
                    }
                    // 缓存
                    return subStories;
                } else {
                    // 初始化
                    subStories = this.initInsOtherData(item, 'stories');
                    Vue.set(item, 'subStories', subStories);
                    // 准备加载
                    this.decodeInsSub(item, 'stories');
                    return item.subStories;
                }
            } else if (item.typeSubCur == 'highlights') {
                // 附加
                var subHighlights = item.subHighlights;
                if (subHighlights) {
                    // 重试
                    if (!subHighlights.loading && subHighlights.isError && subHighlights.isRetry) {
                        subHighlights.loading = true;
                        subHighlights.isError = false;
                        subHighlights.isRetry = false;
                        this.decodeInsSub(item, 'highlights');
                    }
                    // 缓存
                    return subHighlights;
                } else {
                    // 初始化
                    subHighlights = this.initInsOtherData(item, 'highlights');
                    Vue.set(item, 'subHighlights', subHighlights);
                    // 准备加载
                    this.decodeInsSub(item, 'highlights');
                    return item.subHighlights;
                }
            } else {
                // 不会出现这种情况
                return item;
            }
        },
        // 字符串Base64编码
        toBase64(str) {
            // 创建一个 TextEncoder 实例
            const encoder = new TextEncoder();
            // 将字符串转换为一个 Uint8Array
            const byteArray = encoder.encode(str);
            // 转Base64
            let binary = '';
            const len = byteArray.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(byteArray[i]);
            }
            return btoa(binary);
        },
        // 生成UUID
        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        // 错误提示
        errorTips(msg) {
            this.$toast({
                text: msg,
                type: 'fail',
                idValue: "allBox"
            });
        },
        // 更新窗口大小
        updateWindowSize() {
            {
                // 计算没有图片外框高度
                this.noImageHeight = window.innerHeight - 263;
                // 没有目的地节点占位的情况下还可以再高点
                if (!this.node) this.noImageHeight += 85;
            }
            {
                // 计算预览图最终宽度
                // 362是外面所有宽，60是里面左边距，4是容错
                var boxWigth = window.innerWidth - 362 - 60 - 4;
                // 最小宽，200是需求规定，20是外边距
                var minWidth = 200 + 20;
                // 最大宽，340是需求规定，20是外边距
                var maxWidth = 340 + 20;
                // 一行放几个
                var lineCount = Math.floor((boxWigth/minWidth+boxWigth/maxWidth)/2);
                // 每个的宽度，20是外边距
                this.viewImgWigth = Math.floor(boxWigth / lineCount) - 20;
                // 赋值一行放几个
                this.lineCount = lineCount;
            }
        },
        // 加载目的地节点
        loadDestNode() {
            taskListUtils.imageSaverRequest("/loadTaskDestDrive", {}, res => {
                if (res.code == 200) {
                    commonUtils.updateImageSaverDestNode(res.data);
                } else {
                    commonUtils.updateImageSaverDestNode(null);
                }
            });
        },
        // 切换Ins类型选择
        selectInsType(index, type) {
            var insData = this.insDatas[index];
            // 切换
            insData.typeSubCur = type;
            // 是否重试
            if (insData.typeSub != type) {
                if (type == 'posts') {
                    if (insData.subPosts && !insData.subPosts.loading && insData.subPosts.isError && insData.subPosts.msg!='no_data') {
                        insData.subPosts.isRetry = true;
                    }
                } else if (type == 'reels') {
                    if (insData.subReels && !insData.subReels.loading && insData.subReels.isError && insData.subReels.msg!='no_data') {
                        insData.subReels.isRetry = true;
                    }
                } else if (type == 'stories') {
                    if (insData.subStories && !insData.subStories.loading && insData.subStories.isError && insData.subStories.msg!='no_data') {
                        insData.subStories.isRetry = true;
                    }
                } else if (type == 'highlights') {
                    if (insData.subHighlights && !insData.subHighlights.loading && insData.subHighlights.isError && insData.subHighlights.msg!='no_data') {
                        insData.subHighlights.isRetry = true;
                    }
                }
            }
        },
        // 增加更多
        addInstagramItems(index, data, typeSubSelect) {
            // 提示
            if (data.list.length==0 && data.next) {
                this.$toast({
                    text: 'Parsing, please try again later.',
                    type: 'notice',
                    idValue: "allBox"
                });
            }
            var insData = this.insDatas[index];
            var typeSub = insData.typeSub;
            if (typeSub == typeSubSelect) {
                insData.isLoadedNext = true;
                insData.next = data.next;
                insData.list = insData.list.concat(data.list);
            } else if (typeSubSelect == 'posts') {
                insData.subPosts.isLoadedNext = true;
                insData.subPosts.next = data.next;
                insData.subPosts.list = insData.subPosts.list.concat(data.list);
            } else if (typeSubSelect == 'reels') {
                insData.subReels.isLoadedNext = true;
                insData.subReels.next = data.next;
                insData.subReels.list = insData.subReels.list.concat(data.list);
            } else if (typeSubSelect == 'stories') {
                insData.subStories.isLoadedNext = true;
                insData.subStories.next = data.next;
                insData.subStories.list = insData.subStories.list.concat(data.list);
            } else if (typeSubSelect == 'highlights') {
                insData.subHighlights.isLoadedNext = true;
                insData.subHighlights.next = data.next;
                insData.subHighlights.list = insData.subHighlights.list.concat(data.list);
            }
            this.isLoadPreviewImage = true;
        },
        // 更新任务目的地云盘
        updateTaskDestDrive(node) {
            // 准备节点信息
            var tempNode = {};
            // 获取文件夹ID
            if (node.pnode) {
                tempNode.folder = node.id;
            } else {
                tempNode.folder = node.rootId;
            }
            // 获取云盘信息
            var path = [];
            var temp = node;
            while (temp.pnode) {
                path.push({id:temp.id,name:temp.name});
                temp = temp.pnode;
            }
            path.push({id:temp.rootId,name:temp.name});
            tempNode.path = JSON.stringify(path);
            tempNode.id = temp.id;
            tempNode.type = temp.driveType;
            // 更新节点参数准备
            var data = {};
            data.id = tempNode.id;
            data.dt = tempNode.type;
            data.n = this.toBase64(tempNode.path);
            data.pt = tempNode.folder;
            // 更新节点请求
            taskListUtils.imageSaverRequest("/updateTaskDestDrive", data, res => {
                if (res.code == 200) {
                    // 更新成功
                    commonUtils.updateImageSaverDestNode(tempNode);
                } else {
                    // 更新失败
                    commonUtils.updateImageSaverDestNode(null);
                    this.errorTips(res.message);
                }
            });
        },
        // 只能输入1行insUrls
        limitRowsInsUrls() {
            if (this.insUrls.split('\n').length > 1) {
                this.insUrls = this.insUrlsLast;
            } else {
                this.insUrlsLast = this.insUrls;
            }
            setTimeout(() => {
                this.insInputHeight = this.$refs.insInputEle.$el.offsetHeight;
            }, 0);
            // 自动解析
            this.autoDecodeIns();
        },
        // 是否是可以解析的链接
        autoDecodeIns() {
            // 正在解析，则跳过
            if (this.insEncodeing) return;
            // 当前网址（目前只适配：只能输入1行insUrls）
            var url = this.insUrls;
            var prefix = 'https://www.instagram.com';
            // 前缀判断
            if (url.startsWith(prefix)) {
                // 移除前缀，得到路径
                var path = url.substring(prefix.length);
                // 单贴子判断
                if (path.indexOf('/p/')!=-1 || path.indexOf('/reel/')!=-1 || path.indexOf('/reels/')!=-1) {
                    if (this.hasInsPostsId(path)) {
                        // https://www.instagram.com/reels/C_2WhIQxbho/
                        // https://www.instagram.com/reel/C3UXrB_RhYV/?utm_source=ig_web_copy_link
                        // https://www.instagram.com/p/C3Nc99vxOK8/?utm_source=ig_web_copy_link
                        this.decodeInstagram();
                        return;
                    } else {
                        // https://www.instagram.com/angela_zhangshaohan/reel/C7ditKIyWC6/
                        // https://www.instagram.com/angela_zhangshaohan/p/C6xYxk_yJLd/
                        // 第二个/的下标
                        var index = path.indexOf("/", path.indexOf("/") + 1);
                        // 去掉用户名
				        path = path.substring(index);
                        // 再次判断
                        if (this.hasInsPostsId(path)) {
                            this.decodeInstagram();
                            return;
                        }
                    }
                }
                // 故事判断
                if (path.startsWith('/stories/')) {
                    if (!path.startsWith('/stories/highlights/')) {
                        if (path.length > '/stories/'.length) {
                            // https://www.instagram.com/stories/carauii/
                            this.decodeInstagram();
                            return;
                        }
                    }
                }
                // 视频判断
                if (path.endsWith("/reels/") || path.endsWith("/reels")) {
                    // https://www.instagram.com/carauii/reels/
                    this.decodeInstagram();
                    return;
                }
                // 标记判断
                if (path.endsWith("/tagged/") || path.endsWith("/tagged")) {
                    // https://www.instagram.com/abnonosleep/tagged/
                    this.decodeInstagram();
                    return;
                }
                // 突出故事判断
                if (path.startsWith('/stories/highlights/')) {
                    if (path.length > '/stories/highlights/'.length) {
                        // https://www.instagram.com/stories/highlights/18034478860595723/
                        this.decodeInstagram();
                        return;
                    }
                }
                // 突出故事（自定义）判断
                if (path.startsWith('/highlights/')) {
                    if (path.length > '/highlights/'.length) {
                        // https://www.instagram.com/highlights/abnonosleep/
                        this.decodeInstagram();
                        return;
                    }
                }
                // 总贴子判断
                var prefix2 = 'https://www.instagram.com/';
                if (url.startsWith(prefix2)) {
                    var username = url.substring(prefix2.length);
                    // 如果有斜杠
                    if (username.indexOf("/") != -1) {
                        // 包含多个斜杠则不是
                        if (username.indexOf("/") != username.lastIndexOf("/")) {
                            username = '';
                        } else {
                            // 去掉斜杠
                            username = username.substring(0, username.indexOf("/"));
                        }
                    }
                    // 如果用户名不是空白
                    if (username.length > 0) {
                        this.decodeInstagram();
                        return;
                    }
                }
            }
        },
        // 是否有Ins贴子ID
        hasInsPostsId(path) {
            if (path.startsWith('/p/') || path.startsWith('/reel/') || path.startsWith('/reels/')) {
                // 第二个/的下标
                var index = path.indexOf("/", path.indexOf("/") + 1);
                // 得到贴子ID
                var postId = path.substring(index + 1);
                // 移除后面无关信息
                if (postId.indexOf("/") != -1) postId = postId.substring(0, postId.indexOf("/"));
                // 再次判断贴子ID是否正确
                if (postId.length == 11) return true;
            }
            return false;
        },
        // 解析Instagram
        decodeInstagram() {
            this.insEncodeing = true;
            var starts = [];
            var urls = this.insUrls.split('\n');
            for (var i = 0; i < urls.length; i++) {
                starts[i] = '';
            }
            taskListUtils.imageSaverRequest("/decodeInstagram", { urls: urls, starts: starts }, res => {
                this.insEncodeing = false;
                if (res.code == 200) {
                    this.insDatas = res.data;
                    // 初始化当前选择的类型
                    for(var i=0; i<this.insDatas.length; i++) {
                        Vue.set(this.insDatas[i], 'pageIndex', 1);
                        Vue.set(this.insDatas[i], 'isLoadedNext', false);
                        Vue.set(this.insDatas[i], 'typeSubCur', this.insDatas[i].typeSub);
                    }
                    this.isLoadPreviewImage = true;
                } else {
                    this.errorTips(res.message);
                }
            }, err => {
                this.insEncodeing = false;
                this.insDatas = [{list:[]}];
            });
        },
        // 解析Ins附加数据
        decodeInsSub(item, type) {
            // 参数准备
            var param = {starts:['']};
            if (type == 'posts') {
                param.urls = ['https://www.instagram.com/'+item.insUsername+'/'];
            } else if (type == 'reels') {
                param.urls = ['https://www.instagram.com/'+item.insUsername+'/reels/'];
            } else if (type == 'stories') {
                param.urls = ['https://www.instagram.com/stories/'+item.insUsername+'/'];
            } else if (type == 'highlights') {
                param.urls = ['https://www.instagram.com/highlights/'+item.insUsername+'/'];
            }
            // 开始请求
            if (param.urls) {
                taskListUtils.imageSaverRequest("/decodeInstagram", param, res => {
                    if (res.code == 200) {
                        if (res.data[0].list.length == 0) {
                            var msg = res.data[0].msg;
                            // 失败
                            if (type == 'posts') {
                                item.subPosts.loading = false;
                                item.subPosts.isError = true;
                                item.subPosts.msg = msg;
                            } else if (type == 'reels') {
                                item.subReels.loading = false;
                                item.subReels.isError = true;
                                item.subReels.msg = msg;
                            } else if (type == 'stories') {
                                item.subStories.loading = false;
                                item.subStories.isError = true;
                                item.subStories.msg = msg;
                            } else if (type == 'highlights') {
                                item.subHighlights.loading = false;
                                item.subHighlights.isError = true;
                                item.subHighlights.msg = msg;
                            }
                        } else {
                            // 成功
                            res.data[0].pageIndex = 1;
                            res.data[0].isLoadedNext = false;
                            if (type == 'posts') {
                                item.subPosts = res.data[0];
                            } else if (type == 'reels') {
                                item.subReels = res.data[0];
                            } else if (type == 'stories') {
                                item.subStories = res.data[0];
                            } else if (type == 'highlights') {
                                item.subHighlights = res.data[0];
                            }
                            this.isLoadPreviewImage = true;
                        }
                    } else {
                        // 异常
                        this.errorTips(res.message);
                    }
                });
            }
        },
    }
};
</script>

<style>
/* 修复显示表单的BUG */
body>form {
    display: none;
}

/* 整个图片保存 */
.image_saver_body {
    top: 90px;
    height: calc(100% - 90px);
    color: black;
    position: relative;
    background-color: #F2F7FE;
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
}

/* 控制主要内容 */
.image_saver_box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}

/* 主要内容 */
.image_saver_content {
    height: 100%;
    position: relative;
}

/* 底部波浪背景 */
.image_saver_body .task-buttom {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
}

/* 返回顶部 */
.image_saver_backtop>div {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-image: url("../../assets/images/imageSaver/backtopNormal.svg");
    background-repeat: no-repeat;
    background-position: center;
}
.image_saver_backtop>div:hover {
    background-image: url("../../assets/images/imageSaver/backtopHover.svg");
}
.image_saver_backtop>div:active {
    background-image: url("../../assets/images/imageSaver/backtopActive.svg");
}

/* 标签 */
.image_saver_content>.old_tabs {
    padding: 40px 0px 0px 50px;
    height: 100%;
    box-sizing: border-box;
}

.image_saver_content .old_tab {
    overflow: auto;
}

/* 标签体内容 */
.image_saver_body .old_tab {
    height: 100%;
    margin-right: 2px;
    padding-right: 48px;
}

/* 滚动条 */
.image_saver_body .old_tab::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

.image_saver_body .old_tab::-webkit-scrollbar-thumb {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #BECAE4;
    min-height: 100px;
}

/* Web网址和按钮 */
.imagesaver_input_button {
    padding-bottom: 20px;
    display: flex;
    gap: 20px;
}

/* 输入框样式 */
.imagesaver_input>textarea {
    max-height: 93px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

/* Web网址 */
.imagesaver_input_button textarea {
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    padding: 14px 20px;
    font-size: 14px;
}

/* Web按钮 */
.imagesaver_input_button>.el-button {
    padding: 0 !important;
    min-width: 220px;
    height: 50px;
    font-size: 16px;
    border-color: #5562B4;
    background-color: #5562B4;
}

.imagesaver_input_button>.el-button--primary:focus {
    border-color: #5562B4;
    background-color: #5562B4;
}

.imagesaver_input_button>.el-button--primary:hover {
    border-color: #3250C9;
    background-color: #3250C9;
}

.imagesaver_input_button>.el-button--primary:active {
    border-color: #1836B0;
    background-color: #1836B0;
}

/* 禁用状态 */
.imagesaver_input_button>.el-button.is-disabled {
    border-color: #C1CBE3;
    background-color: #C1CBE3;
}

.imagesaver_input_button>.el-button.is-disabled:hover {
    border-color: #C1CBE3;
    background-color: #C1CBE3;
}

/* 正在加载文字颜色 */
.imagesaver_input_button>.el-button.is-loading {
    color: #a1addf;
}

/* 正在加载状态 */
.imagesaver_input_button>.el-button.is-loading:before {
    background-color: rgba(255, 255, 255, 0.1);
}

/* 替换加载中图标位置 */
.imagesaver_input_button .el-icon-loading {
    margin-right: 7px;
    vertical-align: middle;
    position: relative;
    bottom: 2px;
}

/* 替换加载中图标 */
.imagesaver_input_button .el-icon-loading::before {
    content: url('../../assets/images/imageSaver/loading.png');
    display: block;
    height: 20px;
    width: 20px;
}

/* Instagram友好空白页 */
.ins_blank {
    width: 1000px;
    margin: 0 auto;
}

/* Instagram友好空白页，文字 */
.ins_blank_text {
    width: 900px;
    font-size: 18px;
    color: #333333;
    line-height: 22px;
    text-align: center;
    margin: 76px auto 50px auto;
}

/* 未解析前，不显示目的地路径 */
.old_tab[data-init=Y]>.image_saver_path {
    display: none;
}

/* 未解析前，输入框特殊处理 */
.old_tab[data-init=Y]>.imagesaver_input_button {
    width: 1000px;
    margin: 60px auto 0px auto;
}
.old_tab[data-init=Y]>.imagesaver_input_button>* {
    height: 64px;
}
.old_tab[data-init=Y]>.imagesaver_input_button>.el-button {
    border-radius: 8px;
}
.old_tab[data-init=Y]>.imagesaver_input_button>.imagesaver_input>textarea {
    min-height: 64px !important;
    height: 64px !important;
    padding: 20px 20px;
    font-size: 16px !important;
}
.old_tab[data-init=N]>.imagesaver_input_button>* {
    height: 50px;
}
.old_tab[data-init=N]>.imagesaver_input_button>.imagesaver_input>textarea {
    min-height: 50px !important;
    height: 50px !important;
    padding: 14px 20px;
    font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_ins.vue